import gql from 'graphql-tag';

const CAMPAIGN_ORDER_BASKET_BY_DATE = gql`
  query campaignOrderBasketByDate($reportId: ID!) {
    campaignOrderTransactionsBasketItemsByDates(
      where: { campaignOrderTransactionReport: { id: $reportId } }
    ) {
      id
      date
      transactions
      revenue
      quantity
    }
  }
`;

export default CAMPAIGN_ORDER_BASKET_BY_DATE;
